import { render, staticRenderFns } from "./ModalHistoricalAppointment.vue?vue&type=template&id=34096f13&"
import script from "./ModalHistoricalAppointment.vue?vue&type=script&lang=js&"
export * from "./ModalHistoricalAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports